'use client';

import { LegalPageLayout } from '../components/legal-page-layout';

export const CookiePolicyPage = () => {
	return <LegalPageLayout documentType="cookie-policy" />;
};
